/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Detail_CollectorInputs */

const vi_receipt_detail_collector = /** @type {(inputs: Receipt_Detail_CollectorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người thu`)
};

/**

* @param {Receipt_Detail_CollectorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_detail_collector = /** @type {((inputs?: Receipt_Detail_CollectorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Detail_CollectorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_detail_collector(inputs)
});